
//Dev
// const UPLOAD_URL = "https://8x1pz40uv9.execute-api.us-east-1.amazonaws.com/dev/uploadfile/"
// const BASE_URL_A = "https://zbw3bnwar6.execute-api.us-east-1.amazonaws.com/dev/";
// const BASE_URL_B = "https://7l3rsnlkak.execute-api.us-east-1.amazonaws.com/dev/";
// const BASE_URL_C = "https://j92dsmz3nd.execute-api.us-east-1.amazonaws.com/dev/";
// const BASE_URL_D = "https://hj185uuju3.execute-api.us-east-1.amazonaws.com/dev/";

// localStorage
// const UPLOAD_URL = localStorage.getItem("UPLOAD_URL") || "https://8x1pz40uv9.execute-api.us-east-1.amazonaws.com/dev/uploadfile/"
// const BASE_URL_A = localStorage.getItem("BASE_URL_A") || "https://zbw3bnwar6.execute-api.us-east-1.amazonaws.com/dev/";
// const BASE_URL_B = localStorage.getItem("BASE_URL_B") || "https://7l3rsnlkak.execute-api.us-east-1.amazonaws.com/dev/";
// const BASE_URL_C = localStorage.getItem("BASE_URL_C") || "https://j92dsmz3nd.execute-api.us-east-1.amazonaws.com/dev/";

//Prod Testing
const UPLOAD_URL = "https://okxvsyvxq1.execute-api.us-east-1.amazonaws.com/prod/uploadFile"
const BASE_URL_A = " https://xywfgrd3z1.execute-api.us-east-1.amazonaws.com/prod/"
const BASE_URL_B = "https://p3nj2i4q83.execute-api.us-east-1.amazonaws.com/prod/"
const BASE_URL_C = "https://emixjbmpm9.execute-api.us-east-1.amazonaws.com/prod/"
const BASE_URL_D = "https://bq9eqnjc6h.execute-api.us-east-1.amazonaws.com/prod/"

// const BASE_URL_A = "  http://localhost:4000/dev/"
// const BASE_URL_B = "  http://localhost:5000/dev/"
// const BASE_URL_C = "  http://localhost:7000/dev/"
// const BASE_URL_D = "  http://localhost:2000/dev/"

export const environment = {
  production: false,
  upload: UPLOAD_URL,
  //Auth 
  loginUser: BASE_URL_A + "loginUser",
  forgotPassword: BASE_URL_A + "forgotPassword",
  resetPassword: BASE_URL_A + "resetPassword",
  verifyOtp: BASE_URL_A + "verifyOtp",


  getAllClients: BASE_URL_A + "getAllClient",
  createClient: BASE_URL_A + "createClient",
  getClient : BASE_URL_A + "getClient",
  updateClient: BASE_URL_A + "updateClient",
  deleteClient: BASE_URL_A + "deleteClient",

  getAllCenterWithCount: BASE_URL_A + "getAllCenterWithCount",


  createCenter: BASE_URL_A + "createCenter",
  updateCenter: BASE_URL_B + "updateCenter",
  deleteCenter: BASE_URL_B + "deleteCenter",


  getAllDepartmentWithCount : BASE_URL_B + "getDeptWithCount",
  createDepartment: BASE_URL_A + "createDepartment",
  updateDepartment: BASE_URL_B + "updateDepartment",
  deleteDepartment: BASE_URL_B + "deleteDepartment",


  getAllRole : BASE_URL_B + "getRolesWithCount",
  createRole: BASE_URL_A + "createRole",
  updateRole: BASE_URL_B + "updateRole",
  deleteRole: BASE_URL_A + "deleteRole",


  getAllUsers: BASE_URL_A + "getAllUsers",
  createUser: BASE_URL_A + "createUser",
  updateUser: BASE_URL_A + "updateUser",
  deleteUser: BASE_URL_A + "deleteUser",

  // package service starts
  getAllPackages: BASE_URL_C + 'getAllPackage',
  createPackage: BASE_URL_C + 'createPackage',
  updatePackage: BASE_URL_C + 'updatePackage',
  deletePackage: BASE_URL_C + 'deletePackage',

  // addon service starts
  getAllAddons: BASE_URL_C + 'getAllAddon',
  createAddon: BASE_URL_C + 'createAddon',
  updateAddon: BASE_URL_C + 'updateAddon',
  deleteAddon: BASE_URL_C + 'deletePackageAddon',
  assignAddon: BASE_URL_C + 'assignAddon',
  getClientAddons: BASE_URL_C + 'getClientAddons',
  getAllPackageAddon: BASE_URL_C + 'getAllPackageAddon',
  createPackageAddon: BASE_URL_C + 'createPackageAddon',
  updatePackageAddon: BASE_URL_C + 'updatePackageAddon',


  // email config service starts
  getAllEmailConfigs: BASE_URL_C + 'getAllEmailConfig',
  createEmailConfig: BASE_URL_C + 'createEmailConfig',
  updateEmailConfig: BASE_URL_C + 'updateEmailConfig',
  deleteEmailConfig: BASE_URL_C + 'deleteEmailConfig',
  
  //client package
  getAllClientPackage: BASE_URL_B + 'getAllClientPackage',
  createClientPackage: BASE_URL_B + 'createClientPackage',
  updateClientPackage: BASE_URL_B + 'updateClientPackage',

  // whatsapp config service starts
  getAllWhatsAppConfigs: BASE_URL_B + 'getWhatsappConfig',
  createWhatsAppConfig: BASE_URL_B + 'createWhatsappConfig',
  updateWhatsAppConfig: BASE_URL_C + 'updateWhatsappConfig',
  deleteWhatsAppConfig: BASE_URL_C + 'deleteWhatsAppConfig',

  // active directory config service starts
  createActiveDirectoryConfig: BASE_URL_C + 'createActiveDirectoryConfig',
  updateActiveDirectoryConfig: BASE_URL_C + 'updateActiveDirectoryConfig',
  getActiveDirectoryConfig: BASE_URL_C + 'getActiveDirectoryConfigByClientId',
  deleteActiveDirectoryConfig: BASE_URL_C + 'deleteActiveDirectoryConfig',



  createGoogleConfig: BASE_URL_C + 'createGoogleTokenConfig',
  updateGoogleConfig: BASE_URL_C + 'updateGoogleTokenConfig',
  getGoogleConfigByClientId: BASE_URL_C + 'getGoogleConfigByClientId',
  deleteGoogleConfig: BASE_URL_C + 'deleteGoogleTokenConfig',
  //counter component
  getCounterById: BASE_URL_C + 'getCounterById',
  updateCounter: BASE_URL_C + 'updateCounter',
  createCounter: BASE_URL_C + 'createCounter',

  // Assign pipeline
  createPipeLine: BASE_URL_B + "createPipeline",

  // Feature service starts
  getAllFeatures: BASE_URL_C + 'getAllFeature',
  createFeature: BASE_URL_C + 'createFeature',
  updateFeature: BASE_URL_C + 'updateFeature',
  deleteFeature: BASE_URL_C + 'deleteFeature',
  findAndCountAllFeature: BASE_URL_C + 'findAndCountAllFeature',

  createPackageSubscription:BASE_URL_C + 'createPackageSubscription',
  getAllPackageSubscription:BASE_URL_C + 'getAllPackageSubscription',
  updatePackageSubscription:BASE_URL_C + 'updatePackageSubscription',
  getPackageSubscriptionById:BASE_URL_C + 'getPackageSubscriptionById',
  deletePackageSubscription:BASE_URL_C + 'deletePackageSubscription',

  createAddonSubscription:BASE_URL_C + 'createAddonSubscription',
  getAllAddonSubscription:BASE_URL_C + 'getAllAddonSubscription',
  updateAddonSubscription:BASE_URL_C + 'updateAddonSubscription',
  getAddonSubscriptionById:BASE_URL_C + 'getAddonSubscriptionById',
  deleteAddonSubscription:BASE_URL_C + 'deleteAddonSubscription',


  //Payment 
  proformaPackageInvoice:BASE_URL_C + 'proformaPackageInvoice',
  generatePackageInvoice:BASE_URL_C + 'generatePackageInvoice',
  getAllPackageInvoices:BASE_URL_C + 'getAllPackageInvoices',
  cancelAndRefundSubscription:BASE_URL_C + 'cancelAndRefundSubscription',
  restartSubscription:BASE_URL_C + 'restartSubscription',
  upgradePackageSubscription:BASE_URL_C + 'upgradeSubscription',
  proformaAddonInvoice:BASE_URL_C + 'proformaAddonInvoice',
  onboardExistingClient: BASE_URL_D + 'onboardExistingClient',

  
  
};


